import React from "react";
import Map from "../../components/GoogleMap/GoogleMap";
import {useSelector} from "react-redux";
import {getCurrentSite} from "../../redux/Selectors/sites.selectors";
import {isEmpty} from "lodash";

function SitesMap() {
  const selectedLocation = useSelector(getCurrentSite);
  const {selectedAddress = {}} = selectedLocation;

  return (
    <div>
      <div style={{height: "285px"}}>
        <Map address={!isEmpty(selectedAddress) ? selectedAddress["label"] : ""} />
      </div>
    </div>
  );
}

SitesMap.propTypes = {};

export default SitesMap;
